import { BUNDLE_SMALL_NAME, getOneBundleByInstant } from "../../../modes/normalMode/BundleResourceConfig";
import { pawnShopBackpackObjI, pawnShopGameObjI } from "./const/pawnShopConst";

const {ccclass, property} = cc._decorator;

@ccclass
export default class pawnShopRole extends cc.Component {

    @property({type:cc.Node,tooltip:"角色显示的图片"})
    roleSp:cc.Node = null;

    objData:pawnShopGameObjI | pawnShopBackpackObjI = null;

    setSp(spPath:string){
        getOneBundleByInstant(BUNDLE_SMALL_NAME.pawnShopGameBundle).load(`${spPath}`,cc.SpriteFrame,(err,spr:cc.SpriteFrame)=>{
            if(err){
                console.error("#pawnShopRole.ts 加载角色图片失败 #18")
                return;
            }
            this.roleSp.getComponent(cc.Sprite).spriteFrame = spr;
        });
    }

    bindDate(objData:pawnShopGameObjI | pawnShopBackpackObjI){
        this.objData = objData;
    }

    //移动动画
    moveAni(){
        const onceTime:number = 0.1;
        const width = 2;
        let tween = cc.tween(this.roleSp)
        .by(onceTime, {x: width, y: width})
        .by(onceTime, {x: 0, y: -width})
        .by(onceTime, {x: -width, y: -width})
        .by(onceTime, {x: -width, y: 0})
        .by(onceTime, {x: 0, y: width})
        .by(onceTime, {x: width, y: 0});
        cc.tween(this.roleSp).repeatForever(tween).start();
    }

    //待机动画
    standAni(){
        cc.Tween.stopAllByTarget(this.roleSp);
        this.roleSp.setPosition(cc.v2(0,0));
    }
    
}
